<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="article-page">
      <div class="article-inner">
        <img :src="imageList" alt="" style="width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "article",
  data() {
    return {
        isimage:'false',
        imageList:''
    };
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if(this.$route.query.url!=''){
          var part = this.$route.query.url.split('_')[0]
          var article = this.$route.query.url.split('_')[1]
          Axios.get('json/articleContent.json').then((res)=>{
            if(part=='productDynamic' || part == 'activities'){
              this.isimage = true;
              this.imageList = res.data[part][article]
            }
            else{
              const div = document.createElement('div');
              div.innerHTML = res.data[part][article].replace(/\+/g, " ")
              document.querySelector('.article-inner').appendChild(div)
            }
        })
      }
      
          
  },
  // methods: {
  //   mdToHtml (markdown) {
  //     // return md.render(markdown)
  //   }
  // }
};
</script>

<style lang="scss" scoped>
::v-deep( .el-breadcrumb) {
  padding: 32px;
  padding-left: 126px;
}
.article-page {
  background: #ffffff;
  .article-inner {
    width: 960px;
    margin: 0 auto;
    .article-title {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3b3946;
      &.l1 {
        font-size: 24px;
        line-height: 33px;
        padding-bottom: 20px;
        border-bottom: 2px solid #f7f7f7;
      }
      &.sub1 {
        font-size: 20px;
        line-height: 48px;
      }
      &.sub2 {
        font-size: 16px;
        line-height: 42px;
      }
    }
    .article-font {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3b3946;
      line-height: 20px;
    }
    .article-img-wrapper {
      width: 100%;
      text-align: center;
      .article-img {
        width: 100%;
      }
    }
  }
}
</style>
